import { HandleMapInteractions } from '../../../../application/useCases/HandleMapInteractions';
import { Position } from '../../../../domain/entities/map.types';
import { useCallback } from 'react';

export const useMapInteractions = (handleMapInteractions: HandleMapInteractions) => {
  const handleMarkerClick = useCallback(
    (markerId: string) => {
      handleMapInteractions.handleMarkerClick(markerId);
    },
    [handleMapInteractions]
  );

  const handleMarkerDrag = useCallback(
    (markerId: string, newPosition: Position) => {
      handleMapInteractions.handleMarkerDrag(markerId, newPosition);
    },
    [handleMapInteractions]
  );

  return {
    handleMarkerClick,
    handleMarkerDrag
  };
};
